import { colors } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Section from './components/Section'

interface ExtraHoursProps {
  extraHourMinutes: number
}

const ExtraHours = ({ extraHourMinutes }: ExtraHoursProps) => {
  return (
    <Section
      title={i18n.t('clock_in.sidepanel.accordion.extra_hours.title')}
      minutes={extraHourMinutes}
      circleColor={colors.malibu1000}
    />
  )
}

export default ExtraHours
